import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { fg } from '@atlassian/jira-feature-gating';
import type { FooterProps } from '../../../types/commands/index.tsx';
import { FOOTER_TEST_ID } from './constants.tsx';

const styles = cssMap({
	root: {
		display: 'flex',
		alignItems: 'center',
		borderBottomLeftRadius: 'inherit',
		borderBottomRightRadius: 'inherit',
		borderTopColor: token('color.border'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		paddingTop: token('space.150'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.200'),
		height: '48px',
	},
});

export const Footer = ({ defaultFooterContent, children }: FooterProps) => {
	const footerChildren = children || defaultFooterContent;

	if (!footerChildren) return null;

	if (fg('compal_jifjam_navigation_new_filters')) {
		return (
			<Box xcss={styles.root} testId={FOOTER_TEST_ID}>
				{footerChildren}
			</Box>
		);
	}

	return <ModalFooterOld data-testid={FOOTER_TEST_ID}>{footerChildren}</ModalFooterOld>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ModalFooterOld = styled.div({
	borderBottomLeftRadius: 'inherit',
	borderBottomRightRadius: 'inherit',

	borderTop: `1px solid ${token('color.border')}`,
	paddingTop: token('space.150'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.200'),
});
